import React from 'react';
import * as ReactGA from 'react-ga';
import { Link } from 'react-router-dom';
import styles from '../item/Item.css';

const articleTags = tagList => {
  return tagList
    .split(' ')
    .map(tag => (
      <Link
        to={`/tag/${tag}`}
        className='tag'
        key={tag}
        onClick={() => ReactGA.event({
          category: 'Links',
          action: 'TagClick',
          label: tag,
        })} >
        {tag}&nbsp;
      </Link>
    ));
};

export const ItemTags = ({ itemTags }) => {
  return (
    <div className={styles.tags}>
      { articleTags(itemTags) }
    </div>  
  );
};
 
